import { createContext, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";

interface NavAction {
  onClick: () => void;
}

interface NavActionsContextType {
  action: NavAction | null;
  setAction: (action: NavAction | null) => void;
}

const NavActionsContext = createContext<NavActionsContextType>({
  action: null,
  setAction: () => {}
});

export const NavActionsProvider = ({ children }: { children: React.ReactNode }) => {
  const [action, setAction] = useState<NavAction | null>(null);
  return <NavActionsContext.Provider value={{ action, setAction }}>{children}</NavActionsContext.Provider>;
};

export const useRegisterNavAction = (onClick: () => void) => {
  const { setAction } = useContext(NavActionsContext);
  const callbackRef = useRef(onClick);

  useLayoutEffect(() => {
    callbackRef.current = onClick;
  });

  useEffect(() => {
    setAction({ onClick: () => callbackRef.current() });
    return () => setAction(null);
  }, [setAction]);
};

export const useNavAction = () => {
  const { action } = useContext(NavActionsContext);
  return action;
};
